var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slogan",class:_vm.className,style:({ position: _vm.position })},[_c('common-img',{staticClass:"slogan-img",attrs:{"src":"https://cdn.vip-wifi.com/fangchan/img/slogan.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }